export default (spec) => {
  let selected = [];

  for (const key in spec) {
    if (spec.hasOwnProperty(key)) {
      if (spec[key]) {
        selected.push(key);
      }
    }
  }

  return selected.join(" ");
};
